<template>
  <tabs>
    <tab :default="true" icon="/img/editor/marker.png" name="Locatie" id="location">
      <h1>
        Locatie
      </h1>

      <location-auto-complete
          v-on:update-location="$root.updateLocation($event)"></location-auto-complete>
    </tab>
    <tab icon="/img/editor/picture.png" name="Stijlen" id="style">
      <h1>
        Stijlen
      </h1>

      <div class="hint text-white text-center md:hidden">
        Swipe opzij voor meer stijlen! &rarr;
      </div>

      <div class="mb-4 overflow-x-scroll md:overflow-x-hidden md:flex-wrap flex sm:flex-row">
        <div v-for="layer in $root.mapStyles"
             :key="layer.slug"
             v-bind:class="[ layer.slug === $root.print.layers ? '' : '' ]"
             v-on:click="$root.print.layers = layer.slug"
             class="flex-shrink-0 md:w-1/5 relative cursor-pointer"
             style="max-height: 80px;"
        >
          <Checkmark v-if="layer.slug === $root.print.layers"/>

          <img class="w-20 square md:w-full rounded-full border-4 border-solid"
               v-bind:class="[ layer.slug === $root.print.layers ? 'border-green-100' : 'border-transparent' ]"
               v-bind:src="$root.tileserver + layer.slug + '/12/2103/1345.png'">
        </div>
      </div>
    </tab>

    <tab icon="/img/editor/text.png" name="Tekst" id="texts" class="tabcontent">
      <h1>
        Teksten
      </h1>

      <label for="title" class="text-white">
        Titel:
        <input id="title" class="py-2 m-0" v-model="$root.print.title"/>
      </label>

      <label for="subtitle" class="text-white">
        Subtitel:
        <input id="subtitle" class="py-2 m-0" v-model="$root.print.subtitle"/>
      </label>
    </tab>
    <tab icon="/img/editor/shopping-cart.png" name="Afronden" id="finish" class="tabcontent"
         :is-last="true">
      <h1>
        Materiaal
        <a @click="$root.showMaterialModal = true"
           style="text-align: center; margin-top: -3px; background: white; color: green; border-radius: 50%; font-size: 15px; width: 30px; height: 30px; display: inline-block; line-height: 30px;"
           title="Materialen">?</a>
      </h1>

      <div id="type" class="grid grid-cols-2 gap-1">
        <editor-button
            v-for="item in $root.materials"
            :key="item.material"
            :active="item.material === $root.print.material"
            v-on:click.native="$root.print.material = item.material"
        >
          <span class="title" style="font-weight: bold;">{{ item.name }}</span>
        </editor-button>
      </div>
      <div id="sizes" class="card-panel collection no-padding space-y-1">
        <h2>Kies je formaat</h2>

        <div class="grid grid-cols-2 gap-1">
          <editor-button
              v-for="sizeOption in $root.sizes"
              v-if="sizeOption.material === $root.print.material"
              :key="sizeOption.name + sizeOption.name"
              :active="$root.print.size === sizeOption.name"
              v-on:click.native="$root.print.size = sizeOption.name"
          >
            <span class="title" style="font-weight: bold;">⌀ {{ sizeOption.name }}cm</span>
            <span class="secondary-content">&euro; {{ sizeOption.price }}</span>
          </editor-button>
        </div>
      </div>
    </tab>
  </tabs>
</template>

<script>
import Tabs from "../Tabs";
import Tab from "../Tab";
import LocationAutoComplete from "../LocationAutoComplete";
import Checkmark from "../Checkmark";
import EditorButton from "../EditorButton";

export default {
  name: "CityCircleTabs",

  components: {
    LocationAutoComplete,
    Tabs,
    Tab,
    Checkmark,
    EditorButton,
  }
}
</script>

<style scoped>

</style>